import { Box, SvgIcon, Typography } from '@mui/material';
import { useMemo } from 'react';
import {
  selectOrganizationName,
  selectOrganizations,
  setActiveOrganizationId,
} from '@/entities/session';
import { useAppDispatch, useAppSelector } from '@/shared/model';
import { Button } from '@/shared/ui';

interface Props {
  presetOrganizationId: string;
  applyPreset: () => void;
  triggerDialogClose: () => void;
}

export function PresetFromDifferentOrganizationContent({
  presetOrganizationId,
  applyPreset,
  triggerDialogClose,
}: Props) {
  const dispatch = useAppDispatch();
  const currentOrganizationName = useAppSelector(selectOrganizationName);
  const organizations = useAppSelector(selectOrganizations);
  const presetOrganizationName = useMemo(() => {
    return organizations?.find(
      (organization) => organization.id === presetOrganizationId,
    )?.name;
  }, [organizations, presetOrganizationId]);

  const handleApplyToPresetOrganization = () => {
    dispatch(setActiveOrganizationId(presetOrganizationId));
  };
  const handleApplyToCurrentOrganization = () => {
    applyPreset();
    triggerDialogClose();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <SvgIcon sx={{ width: 48, height: 48 }} color="info">
        <svg
          viewBox="0 0 24 24"
          stroke="currentColor"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </SvgIcon>
      <Typography align="center">
        Preset successfully imported, but it's from a different organization
      </Typography>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button variant="outlined" onClick={handleApplyToCurrentOrganization}>
          Apply to current organization ({currentOrganizationName})
        </Button>
        {presetOrganizationName && (
          <Button variant="outlined" onClick={handleApplyToPresetOrganization}>
            Apply to preset organization ({presetOrganizationName})
          </Button>
        )}
      </Box>
    </Box>
  );
}
